// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__21jEa","text":"SelectPayment_text__2D5Kz","title":"SelectPayment_title__30HER","btn":"SelectPayment_btn__2qyMo"};